//styles
import "bootstrap/dist/css/bootstrap.css";
import "./assets/scss/theme.scss";
import "./App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";

//components
import Login from "./pages/login";
import Menu from "./components/menu";
import Home from "./pages/authenticated/home";
import MainStage from "./pages/authenticated/mainStage";
import Stage2 from "./pages/authenticated/stage2";
import MascotHouse from "./pages/authenticated/mascotHouse";
import TalentBrandStore from "./pages/authenticated/talentBrandStore";
import ExpoArea from "./pages/authenticated/expoArea";
import Office from "./pages/authenticated/office";
import Repository from "./pages/authenticated/repository";
import Centers from "./pages/authenticated/expoArea/centers";
import DigitalTechnology from "./pages/authenticated/expoArea/digitalTechnology";
import Diversity from "./pages/authenticated/expoArea/diversity";
import Egs from "./pages/authenticated/expoArea/egs";
import Foundation from "./pages/authenticated/expoArea/fundatiton";
import PeoplesStaffing from "./pages/authenticated/expoArea/peoplesStaffing";
import Ranking from "./pages/embeded/ranking";
import DescompressionRoom from "./pages/authenticated/descompressionRoom";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Menu />}>
            <Route path="/home" element={<Home />} />
            <Route path="/home/palco" element={<MainStage />} />
            <Route path="/home/expo-area" element={<ExpoArea />} />
            <Route path="/home/palco2" element={<Stage2 />} />
            <Route path="/home/casa-do-mascote" element={<MascotHouse />} />
            <Route
              path="/home/talent-brand-store"
              element={<TalentBrandStore />}
            />
            <Route path="/home/conheca-escritorio" element={<Office />} />
            <Route
              path="/home/repositorio-materiais"
              element={<Repository />}
            />
            <Route path="/home/ranking" element={<Ranking />} />
            <Route path="/home/descompression-room" element={<DescompressionRoom />} />
            <Route path="/home/centros" element={<Centers />} />
            <Route
              path="/home/digital-tecnologia"
              element={<DigitalTechnology />}
            />
            <Route path="/home/diversidade" element={<Diversity />} />
            <Route path="/home/esg" element={<Egs />} />
            <Route path="/home/ntt-fundacao" element={<Foundation />} />
            <Route path="/home/pessoas" element={<PeoplesStaffing />} />
          </Route>
          <Route path="/ranking-hall" element={<Ranking />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
